import React, { useState } from 'react';
import { useSpring } from '@react-spring/web';
import { useTheme } from 'styled-components';

import { Button } from './CarouselIndicator.styled';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    isActive: boolean;
}

const CarouselIndicator: React.FC<Props> = props => {
    const { isActive, ...rest } = props;
    const [isHovering, setIsHovering] = useState(false);
    const { colors } = useTheme();

    const buttonSpring = useSpring({
        transform: isHovering ? 'scale(1.4)' : 'scale(1)',
        background: isHovering ? `${colors.tertiary.hex}` : `${colors.secondary.tints[0].hex}`
    });

    return (
        <Button
            {...rest}
            style={buttonSpring}
            $isActive={isActive}
            data-hover={isHovering}
            onMouseOver={() => setIsHovering(true)}
            onMouseOut={() => setIsHovering(false)}
        />
    );
};

export default CarouselIndicator;
